export const PRODUCTS_PREFIX = 'products';

export interface ProductsState {
    products: Product[];
    filtered: Product[];
    pageStatus: ProductsPageStates;
    productsForm: ProductForm;
    isFiltered: boolean;
}

export interface Product {
    id: string;
    productName: string;
    productLogin: string;
    description: string;
    productAccess: ProductAccess;
    productPlaceIds: number[] | null;
    isSaved: boolean;
    ulogin: string;
}

export enum ProductsListColumnKeys {
    ID = 'id',
    PRODUCT_NAME = 'product-name',
    PRODUCT_DESCRIPTION = 'product-description',
    PRODUCT_LINK = 'product-link'
}

export enum ProductsPageStates {
    PENDING = 'PENDING',
    FETCH_FORM = 'FETCH_FORM',
    LOADING = 'LOADING',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
    ACTION = 'ACTION'
}

export interface ProductForm {
    product: Pick<Product, 'productName' | 'description'>;
    isEnabled: boolean;
    isValid: boolean;
}

export enum ProductAccess {
    INTERNAL_AD_PUBLISHER = 'INTERNAL_AD_PUBLISHER',
    INTERNAL_AD_READER = 'INTERNAL_AD_READER'
}

export interface ServerProduct {
    productId: number;
    productName: string;
    productAccess: ProductAccess;
    productDescription: string;
    productPlaceIds: number[] | null;
    productLogin: string;
}
